<template>
  <div class="header">
    <MainLogo />
    <RuLogos v-if="$country === 'ru'"/>
    <KzLogos v-else-if="$country === 'kz'"/>
  </div>
</template>

<script>
import MainLogo from './MainLogo.vue';
import RuLogos from './RU/Logos.vue';
import KzLogos from './KZ/Logos.vue';

export default {
  name: 'Header',
  components: { RuLogos, KzLogos, MainLogo },
};
</script>

<style scoped>
.header {
  justify-items: center;
}
</style>
